import Vue from "vue";

const state = {
  header: "UK's first dental supply marketplace",
  subHeader:
    "Easily compare and buy products <br/> from 1000+ dental suppliers...",
  uniqueSellingPoints: [
    {
      header: "Organise Procurement",
      icon: "increased_reach.svg",
      content:
        "All orders from all suppliers <br> are organised under your account"
    },
    {
      header: "Find Deals",
      icon: "risk_free.svg",
      content: "Compare prices of suppliers <br> in 1 place to find great deals"
    },
    {
      header: "Easy Setup",
      icon: "easy_setup.svg",
      content:
        "It's easy to get started and <br> we're here to offer a helping hand"
    }
  ],
  signupHeader: "Lock in great savings for your dental practice",
  signupSubHeader: "Get started today!",
  features: [
    {
      header: "Intuitive Search",
      text:
        "Our intuitive search enables you to easily find products you're looking for by category, brand and many other filters",
      img:
        "https://res.cloudinary.com/mioven/image/upload/v1597167014/dentoholic/search_mock.jpg"
    },
    {
      header: "Price Comparison",
      text:
        "We provide a comparison of supplier's prices for your selected product so you can lock in great savings",
      img:
        "https://res.cloudinary.com/mioven/image/upload/v1597167311/dentoholic/product_mock.jpg"
    }
  ]
};

const getters = {};

const actions = {
  CREATE_LEAD: function(context, payLoad) {
    return Vue.prototype.$axios
      .post("/customers/leads", payLoad)
      .then(response => {
        return response;
      })
      .catch(err => {
        throw new Error(err.response.data.meta.message);
      });
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
